import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { ArticleResponse, ArticleStatus, ArticleStatusCountsResponse } from './types';

/** The list also carries the leader's article counts by status, whatever the filter. */
export type ArticlesListResponse = PaginatedListResponse<ArticleResponse> & {
  total?: number;
  stats?: ArticleStatusCountsResponse;
};

type GetArticlesProps = {
  artistId: string;
  status?: ArticleStatus;
  search?: string;
  offset?: number;
  limit?: number;
  sortColumn?: string;
  sortDirection?: 'asc' | 'desc';
};

/* eslint-disable camelcase */
type QueryParams = {
  limit: number;
  offset?: number;
  status?: ArticleStatus;
  search?: string;
  sort_column?: string;
  sort_direction?: 'asc' | 'desc';
};
/* eslint-enable camelcase */

export async function getArticles({
  artistId,
  status,
  search,
  offset,
  limit = 20,
  sortColumn,
  sortDirection,
}: GetArticlesProps) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/articles`;

  const queryParams: QueryParams = { limit };

  if (offset) queryParams.offset = offset;
  if (status) queryParams.status = status;
  if (search) queryParams.search = search;
  if (sortColumn) queryParams.sort_column = sortColumn;
  if (sortDirection) queryParams.sort_direction = sortDirection;

  const response = await api.executeGetRequest<ArticlesListResponse>(url, queryParams);

  return response.data;
}
